/**
 * Neues Widget Dashboard Component
 * Implementierung für den Hash #widget-dashboard
 */
import React, { useEffect, useState } from 'react';
import { widgetRegistry } from '../widgets/registry';
import { settingsStorage } from '../settings/storage';
import WidgetContainer from '../widgets/components/WidgetContainer';

const Dashboard = ({ changeTitle }) => {
  const [widgetConfigs, setWidgetConfigs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Lade Widget-Konfigurationen beim Start
  useEffect(() => {
    // Setze den Titel der Seite
    if (changeTitle) {
      changeTitle("Widget Dashboard");
    }
    
    const loadWidgetConfigs = async () => {
      try {
        // Synchronisiere Einstellungen mit dem Backend
        await settingsStorage.sync();
        
        // Hole alle Widget-Konfigurationen
        const configs = settingsStorage.getAllConfigs();
        setWidgetConfigs(configs);
        setLoading(false);
      } catch (err) {
        console.error('Error loading widget configurations:', err);
        setError('Fehler beim Laden der Widget-Konfigurationen');
        setLoading(false);
      }
    };

    loadWidgetConfigs();
    
    // Event-Handler für das REFRESH_DASHBOARD-Event
    const handleRefreshDashboard = () => {
      loadWidgetConfigs();
    };
    
    // Füge Event-Listener hinzu
    global.emitter.on('REFRESH_DASHBOARD', handleRefreshDashboard);
    
    // Setze den Titel zurück, wenn die Komponente unmounted wird
    return () => {
      if (changeTitle) {
        changeTitle(null);
      }
      // Entferne Event-Listener
      global.emitter.off('REFRESH_DASHBOARD', handleRefreshDashboard);
    };
  }, []); // Entferne changeTitle aus dem Abhängigkeitsarray

  // Handler für Konfigurationsänderungen
  const handleConfigChange = (updatedConfig) => {
    // Aktualisiere die Konfiguration im Storage
    settingsStorage.updateConfig(updatedConfig.id, updatedConfig);
    
    // Aktualisiere den lokalen State
    setWidgetConfigs(prevConfigs => 
      prevConfigs.map(config => 
        config.id === updatedConfig.id ? updatedConfig : config
      )
    );
    
    // Optional: Speichere Änderungen im Backend
    // settingsStorage.saveToBackend(settingsStorage.getAllConfigs());
  };

  if (loading) {
    return <div className="dashboard-loading">Lade Dashboard...</div>;
  }

  if (error) {
    return <div className="dashboard-error">{error}</div>;
  }

  // Filtere aktive Widgets und sortiere nach Position
  const activeWidgets = widgetConfigs
    .filter(config => config.isActive)
    .sort((a, b) => a.position - b.position);

  return (
    <div className="widget-dashboard">
      <div className="widgets-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gridAutoRows: 'minmax(100px, auto)', gap: '20px' }}>
        {activeWidgets.length > 0 ? (
          activeWidgets.map(config => {
            const widgetDefinition = widgetRegistry.getWidget(config.type);
            
            if (!widgetDefinition) {
              return (
                <div key={config.id} className="widget-error">
                  Unbekannter Widget-Typ: {config.type}
                </div>
              );
            }
            
            return (
              <WidgetContainer
                key={config.id}
                config={config}
                onConfigChange={handleConfigChange}
                loadData={widgetDefinition.loadData || null}
              />
            );
          })
        ) : (
          <div className="no-widgets">
            <p>Keine Widgets konfiguriert oder aktiviert.</p>
            <p>Gehen Sie zu den Einstellungen, um Widgets hinzuzufügen.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Dashboard;
